import type { MissionConfig } from '../../data/missions';

interface MissionCardProps {
  mission: MissionConfig;
  variant?: 'default' | 'selected' | 'compact';
  onClick?: () => void;
  disabled?: boolean;
  actionHint?: string;
}

export function MissionCard({
  mission,
  variant = 'default',
  onClick,
  disabled = false,
  actionHint,
}: MissionCardProps) {
  const isSelected = variant === 'selected';
  const isCompact = variant === 'compact';

  const className = `board-mission-card shrink-0 rounded-xl border p-3 text-left ${
    isSelected
      ? 'border-amber-400/70 bg-amber-400/10'
      : 'border-white/15 bg-white/5'
  } ${isCompact ? 'w-36' : 'w-44'} ${
    onClick && !disabled
      ? 'cursor-pointer transition hover:border-amber-300/50 hover:bg-white/10 active:scale-[0.98]'
      : ''
  } ${disabled ? 'cursor-not-allowed opacity-50' : ''}`;

  const content = (
    <>
      <p className="text-[10px] font-medium uppercase tracking-wide text-white/45">{mission.id}</p>
      <p className={`font-semibold text-amber-100 ${isCompact ? 'text-xs' : 'text-sm'}`}>
        {mission.name}
      </p>
      {!isCompact && (
        <p className="mt-1 line-clamp-3 text-xs text-white/65">{mission.description}</p>
      )}
      <p className="mt-2 text-xs font-semibold text-amber-300">배당 ×{mission.payout}</p>
      {actionHint && (
        <p className="mt-1 text-[10px] font-medium text-amber-200/80">{actionHint}</p>
      )}
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={className}
        onClick={onClick}
        disabled={disabled}
      >
        {content}
      </button>
    );
  }

  return <div className={className}>{content}</div>;
}
